import {
  DownloadPracticeContractPdfArgs,
  SignPracticeContractArgs,
  UploadSignedPracticeContractArgs,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../../backend/functions/functions'

export const signPracticeContract = httpsCallable<SignPracticeContractArgs>(
  functions,
  'signPracticeContract',
)
export const downloadPracticeContractPdf = httpsCallable<DownloadPracticeContractPdfArgs>(
  functions,
  'downloadPracticeContractPdf',
)
export const uploadSignedPracticeContract = httpsCallable<UploadSignedPracticeContractArgs>(
  functions,
  'uploadSignedPracticeContract',
)
